import React from 'react';
import { pictogramLookup } from './pictogram-lookup';
const DEFAULT_SIZE = 80;
export const Pictogram = ({ name, variant = 'color', size = DEFAULT_SIZE, className, }) => {
    const src = pictogramLookup[name][variant];
    return (React.createElement("img", { src: src, alt: `pictogram-${name}-${variant}`, height: size, width: size, className: className }));
};
//# sourceMappingURL=Pictogram.js.map